import { render, staticRenderFns } from "./TFNField.vue?vue&type=template&id=2551cdd6&"
import script from "./TFNField.vue?vue&type=script&lang=ts&"
export * from "./TFNField.vue?vue&type=script&lang=ts&"
import style0 from "./TFNField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports